import clsx from 'clsx';
import CloseButton from '../button/CloseButton';

type VideoModalProps = {
  isOpen: boolean;
  src: string;
  onClose: () => void;
  className?: string;
};

export default function VideoModal({
  isOpen,
  src,
  onClose,
  className,
}: VideoModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 px-4"
      onClick={onClose}>
      <CloseButton
        onClose={onClose}
        variant="secondary"
        iconClassName="h-6 w-6"
      />
      <div className={clsx('w-full max-w-5xl', className)}>
        <div
          className="aspect-auto w-full overflow-hidden rounded-2xl bg-black shadow-2xl"
          onClick={(e) => e.stopPropagation()}>
          <video
            src={src}
            autoPlay
            loop
            controls
            playsInline
            className="h-full w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
}
